import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import FloatingParticles from '../components/animations/FloatingParticles';
import GradientFlow from '../components/animations/GradientFlow';
import MinimalistGrid from '../components/animations/MinimalistGrid';
import GeometricShapes from '../components/animations/GeometricShapes';
import StaticImage from '../components/animations/StaticImage';
import PulseEffect from '../components/animations/PulseEffect';

const AnimationDemo = () => {
  const animations = [
    {
      id: 1,
      name: 'Option 1: Floating Particles',
      description: 'Gentle, slow-moving particles with soft glow - minimal and elegant',
      component: FloatingParticles
    },
    {
      id: 2,
      name: 'Option 2: Abstract Gradient Flow',
      description: 'Smooth, flowing gradient animation with subtle color transitions - very calm and sophisticated',
      component: GradientFlow
    },
    {
      id: 3,
      name: 'Option 3: Minimalist Grid',
      description: 'Subtle grid pattern with gentle fade-in animation - clean and professional',
      component: MinimalistGrid
    },
    {
      id: 4,
      name: 'Option 4: Geometric Shapes',
      description: 'Slow-rotating abstract geometric shapes with transparency - modern and understated',
      component: GeometricShapes
    },
    {
      id: 5,
      name: 'Option 5: Static Elegant Image',
      description: 'High-quality static image of professional networking - no animation, maximum subtlety',
      component: StaticImage
    },
    {
      id: 6,
      name: 'Option 6: Subtle Pulse Effect',
      description: 'Single abstract element with gentle pulsing glow - minimal distraction',
      component: PulseEffect
    }
  ];

  return (
    <div className="dark-container">
      <section className="py-20">
        <div className="dark-content-container">
          <Link to="/" className="body-medium text-[#00FFD1] hover:text-[#6FD2C0] mb-8 inline-block">
            ← Back to Home
          </Link>
          
          <h1 className="display-large text-white mb-6">Animation Options</h1>
          <p className="body-large text-white/85 mb-16 max-w-3xl">
            Preview each animation option below. Each shows how the hero section would look with that animation style.
          </p>

          <div className="space-y-16">
            {animations.map((anim) => {
              const AnimComponent = anim.component;
              return (
                <div key={anim.id} className="border border-white/25 p-8">
                  <h2 className="heading-2 text-white mb-3">{anim.name}</h2>
                  <p className="body-medium text-white/85 mb-6">{anim.description}</p>
                  
                  {/* Preview Box */}
                  <div className="relative h-[500px] bg-black border border-white/25 overflow-hidden">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 h-full p-12">
                      {/* Left - Content */}
                      <div className="space-y-6 flex flex-col justify-center">
                        <img src="/deft-logo.jpg" alt="Deft Experiences" className="w-64" />
                        <h3 className="display-medium text-white">
                          High-signal environments for meaningful growth
                        </h3>
                        <p className="body-medium text-white/85">
                          Join a community of ambitious individuals focused on purposeful connections
                        </p>
                        <div className="flex gap-4">
                          <button className="btn-primary">
                            View Events
                            <ArrowRight size={20} />
                          </button>
                        </div>
                      </div>

                      {/* Right - Animation */}
                      <div className="relative h-full">
                        <AnimComponent />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AnimationDemo;
